import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  CustomModal,
  InputText,
  InputNumeroInteiro,
  CustomCheckbox,
  Btn,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useTomadaModal, { LOAD_MESSAGE } from './TomadaModalHook'

function TomadaModal({ show, data, onModalClose, onModalSave, selectedTp, dispatch }) {
  const { state, localDispatch } = useTomadaModal()

  useEffect(() => {
    localDispatch.start(data)
  }, [data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Salvando tomada', 'Aguarde...'))
        localDispatch
          .save(selectedTp)
          .then(saved => {
            // Deixa o fluxo de sucesso (mensagem/reset) para o case SUCCESS
            onModalSave(saved)
          })
          .catch(() => {})
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox('Tomada salva com sucesso', null))
        dispatch(hideLoadingBox())
        localDispatch.reset()
        break
      default:
        break
    }
  }, [state.loadingMessage, selectedTp])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.clearError()
    }
  }, [state.errorMessage])

  return (
    <CustomModal header="Tomada" isVisible={show} onClose={onModalClose} width={500}>
      <div className="p-grid">
        <div className="p-col-7">
          <InputText
            label="Número de Referência:*"
            value={state.tomada.numero_referencia || ''}
            onChange={v => localDispatch.onChange('numero_referencia', v || '')}
          />
        </div>
        <div className="p-col-5">
          <InputNumeroInteiro
            label="Sequência:*"
            value={state.tomada.sequencia || ''}
            onChange={v => localDispatch.onChange('sequencia', v)}
          />
        </div>

        <div className="p-col-12" style={{ display: 'flex', alignItems: 'flex-end' }}>
          <CustomCheckbox
            checked={!!state.tomada.actived}
            onChange={v => localDispatch.onChange('actived', !!v)}
          >
            Ativa
          </CustomCheckbox>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Btn onClick={() => localDispatch.onBtnSalvarClicked(selectedTp)}>Salvar</Btn>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(TomadaModal)
